import React from 'react';
import './ReprocessConfirmModal.css';

export default function ReprocessInPlaceModal({
  isOpen,
  filename,
  loading = false,
  onConfirm,
  onCancel,
}) {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget && !loading) {
      onCancel?.();
    }
  };

  return (
    <div className="reprocess-modal-overlay" onClick={handleOverlayClick}>
      <div className="reprocess-modal-container" role="dialog" aria-modal="true">
        <div className="reprocess-modal-header">
          <h3 className="reprocess-modal-title">Reprocesar documento</h3>
          <button
            type="button"
            className="reprocess-modal-close"
            onClick={onCancel}
            disabled={loading}
            aria-label="Cerrar"
          >
            ×
          </button>
        </div>

        <p className="reprocess-modal-filename" title={filename}>
          {filename || 'Documento sin nombre'}
        </p>

        <p className="reprocess-modal-hint">
          Se volverá a extraer la información del archivo. Los datos actuales serán{' '}
          <strong>reemplazados</strong>, incluidas las correcciones manuales. El identificador del
          documento no cambia.
        </p>

        <div className="reprocess-modal-actions">
          <button
            type="button"
            className="reprocess-btn-cancel"
            onClick={onCancel}
            disabled={loading}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="reprocess-btn-confirm"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? 'Procesando…' : 'Reprocesar'}
          </button>
        </div>
      </div>
    </div>
  );
}
